import { Text } from '@mnd-frontend/ui';
import { BlueLink } from '../../styles';

const IntroCourse = () => (
  <>
    <Text as="h3" variant="headlineSmall">
      Online intro course
    </Text>
    <Text as="p" variant="body">
      Participate in our online course where we go through the basics of the tool and some best
      practice tips. It doesn’t matter if you are totally new to Mynewsdesk or just feel you need a
      refresher, it suits anyone interested. Online courses are held in different languages and are
      free for all customers.&nbsp;
      <BlueLink href="https://calendly.com/mynewsdeskeducation">Sign up here!</BlueLink>
    </Text>
  </>
);

export default IntroCourse;
